/**
 * Used indirectly by Blur Admin or other legacy modules
 */
import angular from 'angular';
import 'angular-morris-chart/src/angular-morris-chart';
import 'angular-toastr';
import 'angular-chart.js/angular-chart';
//import 'angular-chartist.js';


// WEBPACK FOOTER //
// ./src/mainModule/js/angular-legacy-modules.js